var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wangeditor"},[_c('div',{ref:"toolbar",staticClass:"toolbar",style:(_vm.styleObj)}),_c('div',{ref:"editor",staticClass:"text"})])}
var staticRenderFns = []

export { render, staticRenderFns }